/**
 * BriqueChart의 Y축 관련 기능 구현
 */

// import BriqueChart from './BriqueChart.vue'
import EventHandler from './EventHandler.js'
import BriqueChart from './BriqueChart.vue'

export default {
  /**
   * Y축에서 우 클릭시 표시할 Context Menu 리스트를 구한다.
   * @param {Object}} chartVue Chart Vue 객체
   * @returns Y축의 Context Menu 리스트
   */
  getYAxisContextMenu: (chartVue) => {
    return {
      visible: false,
      selectedSeriesName: '',
      list: [
        { label: chartVue.$t('fdc.CHART_COMPONENT.LABEL.SELECT_Y_PRIMARY_SECONDARY'),
          visible: () => {
            let element = chartVue.$el.children[0]
            return element.data.length >= 2
          },
          disabled: false,
          click: () => {
            let element = chartVue.$el.children[0]
            BriqueChart.openChartModal(element, 'yAxisPrimarySecondarySelection')
          }
        }
      ]
    }
  },

  /**
   * Y축의 우 클릭과 관련한 초기화
   * @param {Object} element Chart Element
   */
  initYAxis (element) {
    let dragLayer = element.querySelectorAll(`.main-svg .draglayer,.main-svg .cartesianlayer`)
    EventHandler.removeAndAddEventListener(dragLayer, `contextmenu.${element.id}_yaxis`, function (e) {
      if (!EventHandler.matches.call(e.target, '.nsdrag,.sdrag,.ndrag,.ytick text')) return

      // visible한 메뉴가 하나도 없으면 메뉴 자체가 안보이게
      console.log('initYAxis', element.parentElement.__vue__)
      if (!element.parentElement.__vue__.yAxisContextMenu.list.some((item) => typeof (item.visible) === 'function' ? item.visible() : item.visible)) {
        return
      }

      element.parentElement.__vue__.yAxisContextMenu.visible = true
      setTimeout(() => {
        let yMenu = document.querySelector(`#yaxis_contextmenu_${element.id}`)

        let x = (e.clientX + yMenu.clientWidth) > document.body.clientWidth ? (e.clientX - yMenu.clientWidth) : e.clientX
        let y = (e.clientY + yMenu.clientHeight) > document.body.clientHeight ? (e.clientY - yMenu.clientHeight) : e.clientY

        yMenu.style.left = `${x}px`
        yMenu.style.top = `${y}px`
      })

      e.stopPropagation()
      e.preventDefault()

      return false
    })

    EventHandler.removeAndAddEventListener(document.body, `click.${element.id}_yaxis_contextmenu`, function (e) {
      // chart split 해제 후 없어진 element이면
      if (_.isEmpty(document.getElementById(element.id))) {
        EventHandler.removeEventListener(document.body, `click.${element.id}_yaxis_contextmenu`)
        return
      }

      if (element.parentElement.__vue__.yAxisContextMenu.visible !== true) {
        return
      }

      element.parentElement.__vue__.yAxisContextMenu.visible = false
    })
  }
}
